///////////////////////////////////////////////////

import { cpOrderFormApiConnector } from 'apiConnector/secondary-market/cp-order/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { secondaryMarketAmendCpOrderFetchedThunk } from 'state/secondaryMarket/cpOrder/cpOrderForm/cpOrderForm.thunks';
import { secondaryMarketAmendCpOrderFetchFailed } from 'state/secondaryMarket/cpOrder/cpOrderForm/original/cpOrderOriginalForm.actions';
import type { EpicWithThunk } from 'state/state.common';

export function loadCpOrderToAmendEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { getOrderById } = cpOrderFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_AMEND_CP_ORDER_FETCH_REQUESTED'),
      mergeMap(({ orderId, tabId }) =>
        getOrderById(orderId).pipe(
          map(response => secondaryMarketAmendCpOrderFetchedThunk(tabId, orderId, response)),
          catchError((err: Error) => of(secondaryMarketAmendCpOrderFetchFailed(tabId, err?.message))),
        ),
      ),
    );
  };
}
